import { useTranslation } from "react-i18next";

export function useTranslateMonths() {
  const { t } = useTranslation();

  const translatedMonthsOptions = [
    {
      id: "0",
      value: "1",
      label: t("january"),
    },
    {
      id: "1",
      value: "2",
      label: t("february"),
    },
    {
      id: "2",
      value: "3",
      label: t("march"),
    },
    {
      id: "3",
      value: "4",
      label: t("april"),
    },
    {
      id: "4",
      value: "5",
      label: t("may"),
    },
    {
      id: "5",
      value: "6",
      label: t("june"),
    },
    {
      id: "6",
      value: "7",
      label: t("july"),
    },
    {
      id: "7",
      value: "8",
      label: t("august"),
    },
    {
      id: "8",
      value: "9",
      label: t("september"),
    },
    {
      id: "9",
      value: "10",
      label: t("october"),
    },
    {
      id: "10",
      value: "11",
      label: t("november"),
    },
    {
      id: "11",
      value: "12",
      label: t("december"),
    },
  ];

  return { translatedMonthsOptions };
}
